// TODO: deprecated — only consumed by the legacy FileModal via APIProviders.
// FileModal is no longer triggered by any call site (replaced by AddImageModal
// / library panel). Safe to delete with FileModal cleanup.
import React from "react";
import PropTypes from "prop-types";
import i18n from "i18next";
import { Button, Row, Col, Container, FormGroup, FormControl } from "react-bootstrap";
import AppModal from "../../../../common/modal/AppModal";
import CodePreview from "./CodePreview";
import Select from "react-select";
import "../../../../nav_bar/global_config/_reactTags.scss";
import Alert from "../../../../common/alert/Alert";
import { extensionHandlers as extensions } from "../../FileHandlers/FileHandlers";
export default class ShapesComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      file: undefined,
      filter: "",
      extensionFilter: this.props.show,
      keywords: [],
      confirmDelete: false,
      errorDeleteAlert: false,
      selectedAnimationType: "",
    };
    this.generatePreview = this.generatePreview.bind(this);
    this.AnimationTypes = {
      arrow: { label: i18n.t("vish_search_types.Arrows"), value: "arrow", icon: "attach_file" },
      edu: { label: i18n.t("vish_search_types.Education"), value: "edu", icon: "image" },
      // 'audio': { label: i18n.t("vish_search_types.Audio"), value: 'audio', icon: 'audiotrack' },
      // 'video': { label: i18n.t("vish_search_types.Video"), value: 'video', icon: 'play_arrow' },
      // 'csv': { label: i18n.t("vish_search_types.CSV"), value: 'csv', icon: 'view_agenda' },
      // 'pdf': { label: i18n.t("vish_search_types.Officedoc"), value: 'pdf', icon: 'picture_as_pdf' },
      //'scormpackage': { label: i18n.t("vish_search_types.Scormfile"), value: 'scormpackage', icon: 'extension' },
      //'webapp': { label: i18n.t("vish_search_types.Link"), value: 'webapp', icon: 'link' },
      //'swf': { label: i18n.t("vish_search_types.Swf"), value: 'swf', icon: 'flash_on' },
      //'xml': { label: i18n.t("vish_search_types.XML"), value: 'xml', icon: 'code' },
      //'obj': { label: i18n.t("vish_search_types.OBJ"), value: 'obj', icon: '3d_rotation' },
      //'edi': { label: i18n.t("vish_search_types.aideapro"), value: 'edi', icon: 'widgets' },
      //'vish': { label: i18n.t("vish_search_types.VISH"), value: 'vish', icon: 'list' },
      // 'json': { label: i18n.t("vish_search_types.JSON"), value: 'json', icon: 'view_agenda' }
      // 'sla': { label: "Objeto 3D", value: 'sla', icon: 'devices_other' },
      // { label: "Objeto 3D", value: 'octet-stream', icon: 'devices_other' },
      // { label: "Objeto 3D", value: 'stl', icon: 'devices_other' },
      // { label: "Otro", value: 'application', icon: 'devices_other' },
    };

    let rooturl = "";
    try {
      rooturl = ideaLibraryRootUrl;
    } catch (err) {}
    if (
      rooturl == null ||
      rooturl == undefined ||
      rooturl === "" ||
      rooturl === "https://ideaenvstoragerelease.blob.core.windows.net/idealenvironment/" ||
      rooturl === process.env.MW_API_URL ||
      rooturl.includes("localhost")
    ) {
      rooturl = "https://cloud.aideapro.ai/middlewareblob/common/";
    }

    this.files = null;
    this.filesAll = [
      {
        id: "file-41606198900611",
        url: rooturl + "aideapro/library/Animasyon/ok/ok1.gif",
        name: "ok1.gif",
        keywords: "",
        mimetype: "image/gif",
      },
      {
        id: "file-12506677912375",
        url: rooturl + "aideapro/library/Animasyon/ok/ok10.gif",
        name: "ok10.gif",
        keywords: "",
        mimetype: "image/gif",
      },
      {
        id: "file-78343816594013",
        url: rooturl + "aideapro/library/Animasyon/ok/ok11.gif",
        name: "ok11.gif",
        keywords: "",
        mimetype: "image/gif",
      },
      {
        id: "file-18805353088871",
        url: rooturl + "aideapro/library/Animasyon/ok/ok12.gif",
        name: "ok12.gif",
        keywords: "",
        mimetype: "image/gif",
      },
      {
        id: "file-59471428699473",
        url: rooturl + "aideapro/library/Animasyon/ok/ok13.gif",
        name: "ok13.gif",
        keywords: "",
        mimetype: "image/gif",
      },
      {
        id: "file-56734361559555",
        url: rooturl + "aideapro/library/Animasyon/ok/ok14.gif",
        name: "ok14.gif",
        keywords: "",
        mimetype: "image/gif",
      },
      {
        id: "file-32377216945160",
        url: rooturl + "aideapro/library/Animasyon/ok/ok15.gif",
        name: "ok15.gif",
        keywords: "",
        mimetype: "image/gif",
      },
      {
        id: "file-37176244152841",
        url: rooturl + "aideapro/library/Animasyon/ok/ok16.gif",
        name: "ok16.gif",
        keywords: "",
        mimetype: "image/gif",
      },
      {
        id: "file-26166262271816",
        url: rooturl + "aideapro/library/Animasyon/ok/ok17.gif",
        name: "ok17.gif",
        keywords: "",
        mimetype: "image/gif",
      },
      {
        id: "file-93694482899388",
        url: rooturl + "aideapro/library/Animasyon/ok/ok18.gif",
        name: "ok18.gif",
        keywords: "",
        mimetype: "image/gif",
      },
      {
        id: "file-71899493918833",
        url: rooturl + "aideapro/library/Animasyon/ok/ok19.gif",
        name: "ok19.gif",
        keywords: "",
        mimetype: "image/gif",
      },
      {
        id: "file-93556446211391",
        url: rooturl + "aideapro/library/Animasyon/ok/ok2.gif",
        name: "ok2.gif",
        keywords: "",
        mimetype: "image/gif",
      },
      {
        id: "file-60617952067914",
        url: rooturl + "aideapro/library/Animasyon/ok/ok20.gif",
        name: "ok20.gif",
        keywords: "",
        mimetype: "image/gif",
      },
      {
        id: "file-31963308079878",
        url: rooturl + "aideapro/library/Animasyon/ok/ok21.gif",
        name: "ok21.gif",
        keywords: "",
        mimetype: "image/gif",
      },
      {
        id: "file-37083851217254",
        url: rooturl + "aideapro/library/Animasyon/ok/ok22.gif",
        name: "ok22.gif",
        keywords: "",
        mimetype: "image/gif",
      },
      {
        id: "file-96049287741943",
        url: rooturl + "aideapro/library/Animasyon/ok/ok23.gif",
        name: "ok23.gif",
        keywords: "",
        mimetype: "image/gif",
      },
      {
        id: "file-2555964106884",
        url: rooturl + "aideapro/library/Animasyon/ok/ok24.gif",
        name: "ok24.gif",
        keywords: "",
        mimetype: "image/gif",
      },
      {
        id: "file-87154322328566",
        url: rooturl + "aideapro/library/Animasyon/ok/ok25.gif",
        name: "ok25.gif",
        keywords: "",
        mimetype: "image/gif",
      },
      {
        id: "file-20958308804068",
        url: rooturl + "aideapro/library/Animasyon/ok/ok26.gif",
        name: "ok26.gif",
        keywords: "",
        mimetype: "image/gif",
      },
      {
        id: "file-14475172257718",
        url: rooturl + "aideapro/library/Animasyon/ok/ok27.gif",
        name: "ok27.gif",
        keywords: "",
        mimetype: "image/gif",
      },
      {
        id: "file-9596872319090",
        url: rooturl + "aideapro/library/Animasyon/ok/ok28.gif",
        name: "ok28.gif",
        keywords: "",
        mimetype: "image/gif",
      },
      {
        id: "file-17698158644711",
        url: rooturl + "aideapro/library/Animasyon/ok/ok29.gif",
        name: "ok29.gif",
        keywords: "",
        mimetype: "image/gif",
      },
      {
        id: "file-90316129919118",
        url: rooturl + "aideapro/library/Animasyon/ok/ok3.gif",
        name: "ok3.gif",
        keywords: "",
        mimetype: "image/gif",
      },
      {
        id: "file-11912725908760",
        url: rooturl + "aideapro/library/Animasyon/ok/ok30.gif",
        name: "ok30.gif",
        keywords: "",
        mimetype: "image/gif",
      },
      {
        id: "file-70102329056545",
        url: rooturl + "aideapro/library/Animasyon/ok/ok31.gif",
        name: "ok31.gif",
        keywords: "",
        mimetype: "image/gif",
      },
      {
        id: "file-23084805047138",
        url: rooturl + "aideapro/library/Animasyon/ok/ok32.gif",
        name: "ok32.gif",
        keywords: "",
        mimetype: "image/gif",
      },
      {
        id: "file-43686866978499",
        url: rooturl + "aideapro/library/Animasyon/ok/ok33.gif",
        name: "ok33.gif",
        keywords: "",
        mimetype: "image/gif",
      },
      {
        id: "file-4672743522379",
        url: rooturl + "aideapro/library/Animasyon/ok/ok34.gif",
        name: "ok34.gif",
        keywords: "",
        mimetype: "image/gif",
      },
      {
        id: "file-5010837624335",
        url: rooturl + "aideapro/library/Animasyon/ok/ok35.gif",
        name: "ok35.gif",
        keywords: "",
        mimetype: "image/gif",
      },
      {
        id: "file-51188455651500",
        url: rooturl + "aideapro/library/Animasyon/ok/ok36.gif",
        name: "ok36.gif",
        keywords: "",
        mimetype: "image/gif",
      },
      {
        id: "file-48123704341829",
        url: rooturl + "aideapro/library/Animasyon/ok/ok37.gif",
        name: "ok37.gif",
        keywords: "",
        mimetype: "image/gif",
      },
      {
        id: "file-74251172288320",
        url: rooturl + "aideapro/library/Animasyon/ok/ok38.gif",
        name: "ok38.gif",
        keywords: "",
        mimetype: "image/gif",
      },
      {
        id: "file-29526394006831",
        url: rooturl + "aideapro/library/Animasyon/ok/ok39.gif",
        name: "ok39.gif",
        keywords: "",
        mimetype: "image/gif",
      },
      {
        id: "file-45600861037898",
        url: rooturl + "aideapro/library/Animasyon/ok/ok4.gif",
        name: "ok4.gif",
        keywords: "",
        mimetype: "image/gif",
      },
      {
        id: "file-17341337619616",
        url: rooturl + "aideapro/library/Animasyon/ok/ok40.gif",
        name: "ok40.gif",
        keywords: "",
        mimetype: "image/gif",
      },
      {
        id: "file-14163732048911",
        url: rooturl + "aideapro/library/Animasyon/ok/ok5.gif",
        name: "ok5.gif",
        keywords: "",
        mimetype: "image/gif",
      },
      {
        id: "file-33966271346138",
        url: rooturl + "aideapro/library/Animasyon/ok/ok6.gif",
        name: "ok6.gif",
        keywords: "",
        mimetype: "image/gif",
      },
      {
        id: "file-9542862445723",
        url: rooturl + "aideapro/library/Animasyon/ok/ok7.gif",
        name: "ok7.gif",
        keywords: "",
        mimetype: "image/gif",
      },
      {
        id: "file-15297731972366",
        url: rooturl + "aideapro/library/Animasyon/ok/ok8.gif",
        name: "ok8.gif",
        keywords: "",
        mimetype: "image/gif",
      },
      {
        id: "file-62254042197243",
        url: rooturl + "aideapro/library/Animasyon/ok/ok9.gif",
        name: "ok9.gif",
        keywords: "",
        mimetype: "image/gif",
      },

      // part 2
      {
        id: "file-49509084174132",
        url: rooturl + "aideapro/library/Animasyon/animasyon001.gif",
        name: "animasyon001.gif",
        keywords: "daire,mavi,işaret,yuvarlak,circle,round,blue,mark",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-8483465803188",
        url: rooturl + "aideapro/library/Animasyon/animasyon002.gif",
        name: "animasyon002.gif",
        keywords: "yıldız,sarı,başarı,doğru,star,yellow,success,correct",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-4964203890326",
        url: rooturl + "aideapro/library/Animasyon/animasyon003.gif",
        name: "animasyon003.gif",
        keywords:
          "çizgi,işaret,noktalı çizgili,yeşil,yeşil çizgi,line,mark,dotted line,green,green line",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-11361827652104",
        url: rooturl + "aideapro/library/Animasyon/animasyon004.gif",
        name: "animasyon004.gif",
        keywords:
          "çarpı,siyah,siyah çarpı,hata,yanlış,kapat,çıkış,cross,black,black cross,error,incorrect,close,exit,",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-64554622280553",
        url: rooturl + "aideapro/library/Animasyon/animasyon005.gif",
        name: "animasyon005.gif",
        keywords: "kare,işaret,mavi,mavi kare,square,mark,blue,blue square",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-38158564090716",
        url: rooturl + "aideapro/library/Animasyon/animasyon006.gif",
        name: "animasyon006.gif",
        keywords:
          "ünlem,uyarı,üçgen,sarı,kırmızı,kırmızı ünlem,dikkat,exclamation,warning,triangle,yellow,red,red exclamation,attention",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-88820225459357",
        url: rooturl + "aideapro/library/Animasyon/animasyon007.gif",
        name: "animasyon007.gif",
        keywords: "alkış,kutlama,doğru,el,başarı,applause,celebration,correct,hand,success",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-8924107638879",
        url: rooturl + "aideapro/library/Animasyon/animasyon008.gif",
        name: "animasyon008.gif",
        keywords:
          "ünlem,uyarı,mavi,mavi ünlem,dikkat,exclamation,warning,blue,blue exclamation,attention",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-54647113328666",
        url: rooturl + "aideapro/library/Animasyon/animasyon009.gif",
        name: "animasyon009.gif",
        keywords: "müzik,hoparlör,ses,dans,music,speaker,sound,dance",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-98491175346049",
        url: rooturl + "aideapro/library/Animasyon/animasyon010.gif",
        name: "animasyon010.gif",
        keywords:
          "ünlem,uyarı,kırmızı,kırmızı ünlem,dikkat,exclamation,warning,red,red exclamation,attention",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-85527056627319",
        url: rooturl + "aideapro/library/Animasyon/animasyon011.gif",
        name: "animasyon011.gif",
        keywords: "daire,kırmızı,işaret,yuvarlak,circle,round,red,mark",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-53408952084019",
        url: rooturl + "aideapro/library/Animasyon/animasyon012.gif",
        name: "animasyon012.gif",
        keywords: "tik,doğru,onay,kabul,tick,correct,approval,acceptance",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-14798898195377",
        url: rooturl + "aideapro/library/Animasyon/animasyon013.gif",
        name: "animasyon013.gif",
        keywords: "tik,doğru,onay,kabul,tick,correct,approval,acceptance",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-35959379589642",
        url: rooturl + "aideapro/library/Animasyon/animasyon014.gif",
        name: "animasyon014.gif",
        keywords: "daire,mavi,işaret,yuvarlak,circle,round,blue,mark",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-90830762686272",
        url: rooturl + "aideapro/library/Animasyon/animasyon015.gif",
        name: "animasyon015.gif",
        keywords: "alkış,kutlama,doğru,el,başarı,applause,celebration,correct,hand,success",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-93398916770668",
        url: rooturl + "aideapro/library/Animasyon/animasyon016.gif",
        name: "animasyon016.gif",
        keywords: "müzik,kulaklık,ses,dans,music,earphones,sound,dance",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-52230852944372",
        url: rooturl + "aideapro/library/Animasyon/animasyon017.gif",
        name: "animasyon017.gif",
        keywords: "çarpı,hata,yanlış,kapat,çıkış,cross,error,incorrect,close,exit,",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-10385511033416",
        url: rooturl + "aideapro/library/Animasyon/animasyon018.gif",
        name: "animasyon018.gif",
        keywords: "çizgi,işaret,noktalı çizgili,line,mark,dotted line,",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-59827964336241",
        url: rooturl + "aideapro/library/Animasyon/animasyon019.gif",
        name: "animasyon019.gif",
        keywords: "çizgi,işaret,dalgalı çizgili,line,mark,wavy line,",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-14496608242227",
        url: rooturl + "aideapro/library/Animasyon/animasyon020.gif",
        name: "animasyon020.gif",
        keywords: "alkış,kutlama,doğru,el,başarı,applause,celebration,correct,hand,success",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-76032178571179",
        url: rooturl + "aideapro/library/Animasyon/animasyon021.gif",
        name: "animasyon021.gif",
        keywords: "alkış,kutlama,doğru,el,başarı,applause,celebration,correct,hand,success",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-30968795098803",
        url: rooturl + "aideapro/library/Animasyon/animasyon022.gif",
        name: "animasyon022.gif",
        keywords: "tik,doğru,onay,kabul,tick,correct,approval,acceptance",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-43355731539096",
        url: rooturl + "aideapro/library/Animasyon/animasyon023.gif",
        name: "animasyon023.gif",
        keywords: "tik,doğru,onay,kabul,tick,correct,approval,acceptance",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-18873135673685",
        url: rooturl + "aideapro/library/Animasyon/animasyon024.gif",
        name: "animasyon024.gif",
        keywords: "tik,doğru,onay,kabul,tick,correct,approval,acceptance",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-50494383852867",
        url: rooturl + "aideapro/library/Animasyon/animasyon025.gif",
        name: "animasyon025.gif",
        keywords: "başarı,kutlama,konfeti,success,celebration,confetti",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-70829245989929",
        url: rooturl + "aideapro/library/Animasyon/animasyon026.gif",
        name: "animasyon026.gif",
        keywords: "çarpı,hata,yanlış,kapat,çıkış,cross,error,incorrect,close,exit,",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-32529848219138",
        url: rooturl + "aideapro/library/Animasyon/animasyon027.gif",
        name: "animasyon027.gif",
        keywords: "daire,kırmızı,işaret,yuvarlak,circle,round,red,mark",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-14214463479858",
        url: rooturl + "aideapro/library/Animasyon/animasyon028.gif",
        name: "animasyon028.gif",
        keywords: "çizgi,işaret,line,mark",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-2222819350027",
        url: rooturl + "aideapro/library/Animasyon/animasyon029.gif",
        name: "animasyon029.gif",
        keywords: "çarpı,hata,yanlış,kapat,çıkış,cross,error,incorrect,close,exit,",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-79064704189413",
        url: rooturl + "aideapro/library/Animasyon/animasyon030.gif",
        name: "animasyon030.gif",
        keywords: "dikdörtgen,işaret,rectangle,mark",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-35339186688623",
        url: rooturl + "aideapro/library/Animasyon/animasyon031.gif",
        name: "animasyon031.gif",
        keywords: "emoji,mutlu,happy,gülümseme,smile",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-2040931396890",
        url: rooturl + "aideapro/library/Animasyon/animasyon032.gif",
        name: "animasyon032.gif",
        keywords: "emoji,düşünceli,thoughtful ",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-16478487100535",
        url: rooturl + "aideapro/library/Animasyon/animasyon033.gif",
        name: "animasyon033.gif",
        keywords: "emoji,üzgün,sad",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-4007148128896",
        url: rooturl + "aideapro/library/Animasyon/animasyon034.gif",
        name: "animasyon034.gif",
        keywords: "emoji,tedirgin,uneasy",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-55760846914555",
        url: rooturl + "aideapro/library/Animasyon/animasyon035.gif",
        name: "animasyon035.gif",
        keywords: "emoji,kafası karışık,kararsız,confused,undecided",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-56533035569950",
        url: rooturl + "aideapro/library/Animasyon/animasyon036.gif",
        name: "animasyon036.gif",
        keywords: "emoji,düşünceli,thoughtful ",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-5502647764748",
        url: rooturl + "aideapro/library/Animasyon/animasyon037.gif",
        name: "animasyon037.gif",
        keywords: "müzik,kulaklık,ses,dans,music,earphones,sound,dance",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-12314958185172",
        url: rooturl + "aideapro/library/Animasyon/animasyon038.gif",
        name: "animasyon038.gif",
        keywords: "daire,kırmızı,işaret,yuvarlak,circle,round,red,mark",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-84083997064255",
        url: rooturl + "aideapro/library/Animasyon/animasyon039.gif",
        name: "animasyon039.gif",
        keywords: "dikdörtgen,işaret,rectangle,mark",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-85003427801166",
        url: rooturl + "aideapro/library/Animasyon/animasyon040.gif",
        name: "animasyon040.gif",
        keywords: "kare,işaret,square,mark",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-28480549002741",
        url: rooturl + "aideapro/library/Animasyon/animasyon041.gif",
        name: "animasyon041.gif",
        keywords: "kare,işaret,square,mark",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-56431051910695",
        url: rooturl + "aideapro/library/Animasyon/animasyon042.gif",
        name: "animasyon042.gif",
        keywords: "kare,işaret,square,mark",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-6497593465039",
        url: rooturl + "aideapro/library/Animasyon/animasyon043.gif",
        name: "animasyon043.gif",
        keywords: "çarpı,hata,yanlış,kapat,çıkış,cross,error,incorrect,close,exit,",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-31845452137652",
        url: rooturl + "aideapro/library/Animasyon/animasyon044.gif",
        name: "animasyon044.gif",
        keywords: "soru işareti,question mark",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-595766444296",
        url: rooturl + "aideapro/library/Animasyon/animasyon045.gif",
        name: "animasyon045.gif",
        keywords: "soru işareti,question mark",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-63783448037879",
        url: rooturl + "aideapro/library/Animasyon/animasyon046.gif",
        name: "animasyon046.gif",
        keywords: "soru işareti,question mark",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-51246186373536",
        url: rooturl + "aideapro/library/Animasyon/animasyon047.gif",
        name: "animasyon047.gif",
        keywords: "soru işareti,question mark",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-60697535571339",
        url: rooturl + "aideapro/library/Animasyon/animasyon048.gif",
        name: "animasyon048.gif",
        keywords:
          "ünlem,uyarı,kırmızı,kırmızı ünlem,dikkat,exclamation,warning,red,red exclamation,attention",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-69793781016232",
        url: rooturl + "aideapro/library/Animasyon/animasyon049.gif",
        name: "animasyon049.gif",
        keywords: "daire,kırmızı,işaret,yuvarlak,circle,round,red,mark",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-45115187324713",
        url: rooturl + "aideapro/library/Animasyon/animasyon050.gif",
        name: "animasyon050.gif",
        keywords:
          "ünlem,uyarı,kırmızı,kırmızı ünlem,dikkat,exclamation,warning,red,red exclamation,attention",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-68297057458391",
        url: rooturl + "aideapro/library/Animasyon/animasyon051.gif",
        name: "animasyon051.gif",
        keywords:
          "ünlem,uyarı,kırmızı,kırmızı ünlem,dikkat,exclamation,warning,red,red exclamation,attention",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-24362083740444",
        url: rooturl + "aideapro/library/Animasyon/animasyon052.gif",
        name: "animasyon052.gif",
        keywords: "ünlem,uyarı,dikkat,exclamation,warning",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-15769238706326",
        url: rooturl + "aideapro/library/Animasyon/animasyon053.gif",
        name: "animasyon053.gif",
        keywords:
          "ünlem,uyarı,kırmızı,kırmızı ünlem,dikkat,exclamation,warning,red,red exclamation,attention",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-80371642664577",
        url: rooturl + "aideapro/library/Animasyon/animasyon054.gif",
        name: "animasyon054.gif",
        keywords: "megafon,duyuru,açıklama,megaphone,announcement,statement",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-42945541772879",
        url: rooturl + "aideapro/library/Animasyon/animasyon055.gif",
        name: "animasyon055.gif",
        keywords: "megafon,duyuru,açıklama,megaphone,announcement,statement",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-49703912029632",
        url: rooturl + "aideapro/library/Animasyon/animasyon056.gif",
        name: "animasyon056.gif",
        keywords: "megafon,duyuru,açıklama,megaphone,announcement,statement",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-26139097242",
        url: rooturl + "aideapro/library/Animasyon/animasyon057.gif",
        name: "animasyon057.gif",
        keywords: "megafon,duyuru,açıklama,megaphone,announcement,statement",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-37064151785752",
        url: rooturl + "aideapro/library/Animasyon/animasyon058.gif",
        name: "animasyon058.gif",
        keywords: "daire,kırmızı,işaret,yuvarlak,circle,round,red,mark",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-12924119810119",
        url: rooturl + "aideapro/library/Animasyon/animasyon059.gif",
        name: "animasyon059.gif",
        keywords: "daire,işaret,yuvarlak,circle,round,mark",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-80529953785860",
        url: rooturl + "aideapro/library/Animasyon/animasyon060.gif",
        name: "animasyon060.gif",
        keywords: "çizgi,işaret,dalgalı çizgili,line,mark,wavy line,",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-18342646000011",
        url: rooturl + "aideapro/library/Animasyon/animasyon061.gif",
        name: "animasyon061.gif",
        keywords: "çizgi,işaret,line,mark",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-66637043419303",
        url: rooturl + "aideapro/library/Animasyon/animasyon062.gif",
        name: "animasyon062.gif",
        keywords: "çizgi,işaret,noktalı çizgili,line,mark,dotted line",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-56211562044135",
        url: rooturl + "aideapro/library/Animasyon/animasyon063.gif",
        name: "animasyon063.gif",
        keywords: "çizgi,işaret,noktalı çizgili,line,mark,dotted line",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-18154742124687",
        url: rooturl + "aideapro/library/Animasyon/animasyon064.gif",
        name: "animasyon064.gif",
        keywords: "çizgi,işaret,noktalı çizgili,line,mark,dotted line",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-32647451289301",
        url: rooturl + "aideapro/library/Animasyon/animasyon065.gif",
        name: "animasyon065.gif",
        keywords: "daire,işaret,yuvarlak,circle,round,mark",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-19091137051605",
        url: rooturl + "aideapro/library/Animasyon/animasyon066.gif",
        name: "animasyon066.gif",
        keywords: "müzik,kulaklık,ses,dans,music,earphones,sound,dance",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-6594558326451",
        url: rooturl + "aideapro/library/Animasyon/animasyon067.gif",
        name: "animasyon067.gif",
        keywords: "başarı,kutlama,konfeti,success,celebration,confetti",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-78822674711532",
        url: rooturl + "aideapro/library/Animasyon/animasyon068.gif",
        name: "animasyon068.gif",
        keywords: "başarı,kutlama,konfeti,success,celebration,confetti",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-24957658999011",
        url: rooturl + "aideapro/library/Animasyon/animasyon069.gif",
        name: "animasyon069.gif",
        keywords: "başarı,kutlama,yıldız,success,celebration,star",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-78372284315864",
        url: rooturl + "aideapro/library/Animasyon/animasyon070.gif",
        name: "animasyon070.gif",
        keywords: "çarpı,hata,yanlış,kapat,çıkış,cross,error,incorrect,close,exit,",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-58939138824851",
        url: rooturl + "aideapro/library/Animasyon/animasyon071.gif",
        name: "animasyon071.gif",
        keywords: "daire,işaret,yuvarlak,circle,round,mark",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-34162812365579",
        url: rooturl + "aideapro/library/Animasyon/animasyon072.gif",
        name: "animasyon072.gif",
        keywords: "daire,işaret,yuvarlak,circle,round,mark",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-46154194748419",
        url: rooturl + "aideapro/library/Animasyon/animasyon073.gif",
        name: "animasyon073.gif",
        keywords: "çarpı,hata,yanlış,kapat,çıkış,cross,error,incorrect,close,exit,",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-11883127757127",
        url: rooturl + "aideapro/library/Animasyon/animasyon074.gif",
        name: "animasyon074.gif",
        keywords:
          "kadın,anlatıcı,anlatım,açıklama,sunum,woman,narrator,narration,explanation,presentation",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-79691387281001",
        url: rooturl + "aideapro/library/Animasyon/animasyon075.gif",
        name: "animasyon075.gif",
        keywords:
          "erkek,anlatıcı,anlatım,açıklama,sunum,male,narrator,narration,explanation,presentation",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-6640305225664",
        url: rooturl + "aideapro/library/Animasyon/animasyon076.gif",
        name: "animasyon076.gif",
        keywords:
          "kadın,anlatıcı,anlatım,açıklama,sunum,woman,narrator,narration,explanation,presentation",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-30707261583309",
        url: rooturl + "aideapro/library/Animasyon/animasyon077.gif",
        name: "animasyon077.gif",
        keywords:
          "kadın,anlatıcı,anlatım,açıklama,sunum,woman,narrator,narration,explanation,presentation",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-88388917576215",
        url: rooturl + "aideapro/library/Animasyon/animasyon078.gif",
        name: "animasyon078.gif",
        keywords:
          "erkek,anlatıcı,anlatım,açıklama,sunum,male,narrator,narration,explanation,presentation",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-13219937599642",
        url: rooturl + "aideapro/library/Animasyon/animasyon079.gif",
        name: "animasyon079.gif",
        keywords:
          "erkek,anlatıcı,anlatım,açıklama,sunum,male,narrator,narration,explanation,presentation",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-1487321892995",
        url: rooturl + "aideapro/library/Animasyon/animasyon080.gif",
        name: "animasyon080.gif",
        keywords: "soru işareti,question mark",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-91610349518739",
        url: rooturl + "aideapro/library/Animasyon/animasyon081.gif",
        name: "animasyon081.gif",
        keywords: "çizgi,işaret,line,mark",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-87053359333727",
        url: rooturl + "aideapro/library/Animasyon/animasyon082.gif",
        name: "animasyon082.gif",
        keywords: "megafon,duyuru,açıklama,megaphone,announcement,statement",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-67592945100061",
        url: rooturl + "aideapro/library/Animasyon/animasyon083.gif",
        name: "animasyon083.gif",
        keywords: "dikdörtgen,işaret,rectangle,mark",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-7118452939342",
        url: rooturl + "aideapro/library/Animasyon/animasyon084.gif",
        name: "animasyon084.gif",
        keywords: "kare,işaret,square,mark",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-3767456892899",
        url: rooturl + "aideapro/library/Animasyon/animasyon085.gif",
        name: "animasyon085.gif",
        keywords: "tik,doğru,onay,kabul,tick,correct,approval,acceptance",
        mimetype: "image/svg+xml",
      },
      {
        id: "file-7010407699050",
        url: rooturl + "aideapro/library/Animasyon/animasyon086.gif",
        name: "animasyon086.gif",
        keywords: "soru işareti,question mark",
        mimetype: "image/svg+xml",
      },
    ];
    this.filesAll.sort((a, b) => b.id.localeCompare(a.id));
  }
  render() {
    let empty = true;

    /* = Object.keys(this.props.filesUploaded) */
    this.files = this.filesAll.map((f) => {
      let file = f;
      let type = file.mimetype;
      let icon = "star";
      for (let e in extensions) {
        let ext = extensions[e];

        if (ext.value !== "" && type.match(ext.value)) {
          type = ext.value;
          icon = ext.icon;
        }
      }
      let re = new RegExp(this.state.filter, "gi");
      if (
        (file.keywords && file.keywords.match(re)) ||
        (file.mimetype && file.mimetype.match(this.state.filter)) // Matches written filter
        // && (this.state.extensionFilter === "*" || (file.mimetype && file.mimetype.match(this.state.extensionFilter))) // Matches extension filter
      ) {
        empty = false;
        return { ...file, type, icon };
      }

      return { ...file, type, icon, hide: true };
    });
    //this.files.reverse();

    // let currentExtension = this.props.show === "*" ? this.state.extensionFilter : this.props.show;
    // currentExtension = currentExtension === '*' ? '' : currentExtension;
    // let aux = currentExtension;
    // for (let e in extensions) {
    //     let ext = extensions[e];
    //     if (currentExtension.match(ext.value)) {
    //         aux = ext.value;
    //     }
    // }
    // currentExtension = aux;

    // let fileSelected = this.props.filesUploaded[this.props.idSelected];
    // let download = { // Forces browser download
    //     title: i18n.t('FileModal.FileHandlers.downloadAsFile'),
    //     disabled: !fileSelected,
    //     action: ()=>{
    //         window.download(fileSelected.url, fileSelected.name);
    //     },
    // };
    /*  <h5>{this.props.icon ? <img className="fileMenuIcon" src={this.props.icon } alt=""/> : this.props.name}</h5> */
    return (
      <div className="contentComponent ShapesComponent">
        {/* <h5>{i18n.t("FileModal.APIProviders.MyFilesTitle")}</h5>
            <hr /> */}
        <div className={"filters"} style={{ padding: "0px" }}>
          <FormGroup key="filter">
            <FormControl
              type="text"
              value={this.state.filter}
              placeholder={i18n.t("Filter")}
              id="filterInput"
              autoFocus
              onChange={(e) => {
                this.setState({ filter: e.target.value });
              }}
            />
          </FormGroup>
          {/* <FormGroup key="extfilter">
                    <Select
                        name="form-field-extensions"
                        //value={"arrow"}
                        // disabled = {this.props.show !== "*"}
                        options={Object.values(this.AnimationTypes)}
                        className="selectD"
                        onChange={e => {
                            console.log("AnimationTypes>",e);
                            this.setState({ selectedAnimationType: e.value });}} />
                </FormGroup> */}
        </div>
        <Container>
          <Row
            className="myFilesRow"
            onClick={(e) => {
              this.setState({ preview: false });
              this.props.onElementSelected(undefined, undefined, undefined);
            }}
          >
            {this.files.map((file, i) => {
              let split = file.name.split(".");
              let filetype = file.type; // ? file.type : ((split && (split.length > 1)? split[split.length-1]:'application'));
              let isActive = file.id === this.props.idSelected;
              return (
                <Col
                  key={i}
                  className={"myFile myFileLibrary" + (file.hide ? " hidden" : "")}
                  // style={{ width: "64px", height: "64px", float: "left" }}>
                  xs={4}
                  sm={2}
                  md={2}
                  lg={2}
                >
                  {isActive && 1 === 2 ? (
                    <Button
                      className="deleteButton"
                      onClick={(e) => {
                        this.setState({ confirmDelete: true });
                        e.stopPropagation();
                      }}
                    >
                      <i className="material-icons">delete</i>
                    </Button>
                  ) : null}
                  {isActive && 1 === 2 ? (
                    <Button
                      className="downloadButton"
                      onClick={(e) => {
                        download.action();
                      }}
                    >
                      <i className="material-icons">cloud_download</i>
                    </Button>
                  ) : null}
                  {isActive && this.props.elementSelectedType !== "image" ? (
                    <Button
                      className="previewFileButton"
                      onClick={(e) => {
                        e.stopPropagation();
                        this.setState({ preview: true });
                      }}
                    >
                      {this.props.elementSelectedType === "audio" ? (
                        <i className="material-icons">volume_down</i>
                      ) : (
                        <i className="material-icons">remove_red_eye</i>
                      )}
                    </Button>
                  ) : null}
                  <Button
                    style={{
                      backgroundSize: "contain",
                      backgroundRepeat: "no-repeat",
                      backgroundImage: true /* filetype === 'image'*/
                        ? "url(" + file.url + ")"
                        : "",
                    }}
                    onClick={(e) => {
                      this.props.onElementSelected(
                        file.name,
                        file.url,
                        "image" /* filetype*/,
                        file.id
                      );
                      e.stopPropagation();
                    }}
                    className={"myFileContent" + (isActive ? " active" : "")}
                  >
                    {
                      file.type === "image"
                        ? ""
                        : "" /* <i className="material-icons">{file.icon || "star"}</i> */
                    }
                  </Button>
                  {/* <span className="ellipsis">{file.name}</span> */}
                </Col>
              );
            })}
          </Row>
          {this.state.confirmDelete ? (
            <Alert
              className="pageModal"
              show
              hasHeader
              title={
                <span>
                  <i style={{ fontSize: "14px", marginRight: "5px" }} className="material-icons">
                    delete
                  </i>
                  {i18n.t("messages.confirm_delete_cv")}
                </span>
              }
              cancelButton
              acceptButtonText={i18n.t("messages.OK")}
              onClose={(bool) => {
                if (bool) {
                  this.props.onElementSelected(undefined, undefined, undefined);
                  this.props.deleteFileFromServer(
                    this.props.idSelected,
                    this.props.elementSelected,
                    (status) => {
                      if (!status) {
                        this.setState({ errorDeleteAlert: true });
                      }
                    }
                  );
                }
                this.setState({ confirmDelete: false });
              }}
            >
              <span> {i18n.t("FileModal.APIProviders.confirm_delete")} </span>
              <br />
            </Alert>
          ) : null}
          {empty ? <p className="empty">{i18n.t("FileModal.APIProviders.no_files")}</p> : null}
          {this.state.errorDeleteAlert ? (
            <Alert
              className="pageModal"
              show
              hasHeader
              acceptButtonText={i18n.t("messages.OK")}
              title={
                <span>
                  <i style={{ fontSize: "14px", marginRight: "5px" }} className="material-icons">
                    warning
                  </i>
                  {i18n.t("messages.error")}
                </span>
              }
              onClose={() => {
                this.setState({ errorDeleteAlert: false });
              }}
            >
              <span> {i18n.t("error.deleting")} </span>
              <br />
            </Alert>
          ) : null}
          <AppModal
            className="previewVideoModal"
            show={!!(this.state.preview && this.props.elementSelected)}
            onClose={() => this.setState({ preview: false })}
            title={i18n.t("Preview")}
          >
            {this.generatePreview()}
          </AppModal>
        </Container>
      </div>
    );
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.show !== this.props.show) {
      this.setState({ extensionFilter: nextProps.show });
    }
  }
  componentWillUpdate(nextProps, nextState) {
    if (
      nextProps.filesUploaded &&
      this.props.filesUploaded &&
      nextProps.filesUploaded.length !== this.props.filesUploaded.length
      /* || nextState.filter !== this.state.filter || nextState.extensionFilter !== this.state.extensionFilter*/
    ) {
      // this.props.onElementSelected( undefined, undefined, undefined);
    }
  }
  generatePreview() {
    let item = this.props.elementSelected;
    switch (this.props.elementSelectedType) {
      case "webapp":
      case "pdf":
      case "scormpackage":
        return (
          <iframe src={this.props.elementSelected} frameBorder="0" width={"100%"} height={"400"} />
        );
      case "image":
        return null;
      case "audio":
        return (
          <audio
            src={this.props.elementSelected}
            controls
            width={"100%"}
            height={"400"}
            style={{ width: "100%" }}
          />
        );
      case "video":
        return <video src={this.props.elementSelected} controls width={"100%"} height={"400"} />;
      case "swf":
        return (
          <embed src={this.props.elementSelected} wmode="opaque" width={"100%"} height={"400"} />
        );
      case "xml":
      case "csv":
      case "edi":
      case "vish":
        return <CodePreview source={this.props.elementSelected} />;
      default:
        return null;
    }
  }
}

ShapesComponent.propTypes = {
  /**
   * Filter that indicates what types of files are shown. "*" means all.
   */
  show: PropTypes.any,
  /**
   * Files uploaded to server
   */
  filesUploaded: PropTypes.any,
  /**
   * Identifier of element whose source is being changed (box/slide background). It can be empty
   */
  idSelected: PropTypes.any,
  /**
   * Selected Element type
   */
  elementSelectedType: PropTypes.any,
  /**
   * Element selected from files
   */
  elementSelected: PropTypes.any,
  /**
   * Function that is called when the user selects an element
   */
  onElementSelected: PropTypes.func.isRequired,
  /**
   * Function for deleting files from server
   */
  deleteFileFromServer: PropTypes.func,
};
